<template>
  <main className="main">
    <slot></slot>
  </main>
</template>

<script>
export default {
  setup() {},
};
</script>
